var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex items-center rounded-full px-2.5 py-0.5 font-medium",class:_vm.classes},[(_vm.label)?_c('span',[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]):_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }